<template>
    <div>

        <label>Select Product
            <select v-model="currentProduct" @change="getProductOrderFields">
                <option v-for="product in products" :value="product.id">{{product.name}}</option>
            </select>
        </label>


        <label>Write the message here:
            <textarea v-model="inputString" ref="textArea"></textarea>
        </label>

        <p>You can include any of this variables:</p>

        <div
                v-for="field in currentOrderFields"
                @click="insertToText(field.name)"
        >
            {{field.name}}
        </div>

        <p>Insert sample Data:</p>

        <div
                v-for="(field, index) in currentOrderFields"
        >
            <label>
                {{field.name}}
                <input type="text" v-model="sampleData[index]">
            </label>
        </div>

        <pre>{{previewResult}}</pre>
    </div>
</template>
<script>
    import mustache from 'mustache';
    import axios from 'axios';

    export default {
        data() {
            return {
                inputString: `שלום
זוהי תזכורת ממכבי טבעי לייעוץ רפואי בתאריך {{תאריך התור}} בשעה {{שעת התור}} במרפאת {{מרפאה}} בכתובת {{כתובת}}

לפרטים נוספים 6395*
http://tinyurl.com/hjuxwfc

להתראות
צוות מכבי טבעי`,
                result: '',
                currentProduct: 0,
                currentOrderFields: [],
                products: [],
                dataObject: {},
                sampleData: [],
            }
        },
        mounted() {
            this.getProducts();
        },
        methods: {
            async getProducts() {
                const {data} = await axios.get('/api/products');
                this.products = data;
            },
            async getProductOrderFields() {
                this.currentOrderFields = [];
                const {data} = await axios.get(`/api/products/${this.currentProduct}/order_custom_fields`);
                this.currentOrderFields = data;
            },
            insertToText(text) {

                const stringToAdd = `{{${text}}}`;
                const myField = this.$refs.textArea;

                if (myField.selectionStart || myField.selectionStart === 0) {

                    const startPos = myField.selectionStart;
                    const endPos = myField.selectionEnd;

                    myField.value = myField.value.substring(0, startPos)
                        + stringToAdd
                        + myField.value.substring(endPos, myField.value.length);

                    myField.selectionStart = startPos + stringToAdd.length;
                    myField.selectionEnd = startPos + stringToAdd.length;

                } else {
                    myField.value += stringToAdd;
                }

            }
        },
        computed: {
            previewResult() {

                const parsedTokens = mustache.parse(this.inputString, ['{{', '}}']);

                const tokens = parsedTokens
                    .filter(([tokenType]) => tokenType === 'name')
                    .map(([,tokenName]) => tokenName);

                const uniqTokens = Array.from(new Set(tokens));

                const sampleDataObject = {};

                uniqTokens.forEach(token => {

                    const fieldIndex = this.currentOrderFields.findIndex(field => field.name === token);

                    if (fieldIndex > -1) {
                        return sampleDataObject[token] = this.sampleData[fieldIndex];
                    }

                });

                console.log(sampleDataObject);

               return mustache.render(this.inputString, sampleDataObject);

            }
        }
    }
</script>